import React from 'react';
import { TabPane } from 'rc-tabs';
import TabContent from 'rc-tabs/lib/TabContent';
import 'rc-tabs/assets/index.css';

import { TabsPaneDefaultProps, TabsPanePropTypes } from 'src/components/TabsPane/propTypes';
import S from 'src/components/TabsPane/TabsPane.styles';

const TabsPane = ({ activeKey, children, onTabClick, contentHeight65Vh = false }) => {
  return (
    <S.TabsWrapper
      activeKey={activeKey}
      contentHeight65Vh={contentHeight65Vh}
      destroyInactiveTabPane
      renderTabBar={() => <S.TabBarWrapper onTabClick={onTabClick} />}
      renderTabContent={() => <TabContent animated={false} />}
      >
      {(Array.isArray(children) ? children : [children]).map(child => {
        if (Array.isArray(child)) {
          return child.map(c => (
            <TabPane
              key={c.key}
              tab={c.props.tab}
              withoutPadding={c.props.withoutPadding || false}
            >
              <S.TabPaneWrapper
                key={c.key}
                withoutPadding={c.props.withoutPadding || false}
              >
                {c.props.children}
              </S.TabPaneWrapper>
            </TabPane>
          ));
        }

        if (!child) {
          return null;
        }

        return (
          <TabPane
            key={child.key}
            tab={child.props.tab}
            withoutPadding={child.props.withoutPadding || false}
          >
            <S.TabPaneWrapper
              key={child.key}
              withoutPadding={child.props.withoutPadding || false}
            >
              {child.props.children}
            </S.TabPaneWrapper>
          </TabPane>
        );
      })}
    </S.TabsWrapper>
  );
};

TabsPane.propTypes = TabsPanePropTypes;
TabsPane.defaultProps = TabsPaneDefaultProps;

export default TabsPane;
